import * as core from '../../../../../../../core'
import * as pullRequestKind from '../pull-request-kind'

export const RESOURCE = {
  payload: {
    description: 'Adds or changes specs; merging it approves them',
    enumId: core.dms.models.Enum.Id.from({
      partialId: pullRequestKind.RESOURCE.payload.partialId,
    }),
    id: 'APPROVAL',
    name: 'Approval',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
